module.exports = __webpack_public_path__ + "static/media/natasa_vukadinovic.fff78ff7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/doctors/natasa_vukadinovic.jpg
// module id = 433
// module chunks = 0